<template>
    <div class="container" >

      <b-row class="m-2 ml-lg-5 text-left" style=" font-size: 0.8em; width: 90%;margin-left: 40px;">
        <b-col cols="1"></b-col>
        <b-col>
          <span >Laboratorio <span style="color: red">*</span></span>
          <v-select
              style="width: 90%"
              v-model="proveedor.idLaboratorio"
              placeholder="Selecciona un laboratorio"
              id="idLaboratorio"
              label="nombreLaboratorio"
              required
              :reduce="(variable) => variable.idLaboratorio"
              :options="listLaboratorios"
              @input="obtenerProductosLab()"
              :disabled="deshabilitado"
              :clearable="false"
          > <span slot="no-options">No hay valores configurados disponibles</span>
          </v-select>
        </b-col>
        <b-col>
          <span >Producto a solicitar <span style="color: red">*</span></span>
          <v-select
              style="width: 90%"
              v-model="proveedor.idProductoLaboratorio"
              placeholder="Selecciona un producto"
              id="idProductoLaboratorio"
              label="nombreProducto"
              required
              :reduce="(variable) => variable.idProductoLaboratorio"
              :options="listProductosByLab"
              :disabled="deshabilitado"
              :clearable="false"
          > <span slot="no-options">No hay valores configurados disponibles</span>
          </v-select>
        </b-col>
      </b-row>
      <br/>

      <b-button variant="outline-primary" pill size="sm"
                @click="siguiente()"
                :disabled="proveedor.idLaboratorio === null || proveedor.idProductoLaboratorio === null || deshabilitado"
      >
        <span>Siguiente</span>
      </b-button>
    </div>
</template>
<script>
export default {
  name: "Proveedor",
  props: {
    odtMadre: Object,
    listLaboratorios: Array,
    productosLaboratorios: Array,
    datos: Object,
    deshabilitado: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    listProductosByLab: [],
    proveedor: {
      idLaboratorio: null,
      idProductoLaboratorio: null,
    },

  }),
  created() {
    if (this.odtMadre != null && this.odtMadre.proveedor !== null ){
      this.proveedor = this.odtMadre.proveedor;
    }
  },
  methods: {
    siguiente(){
      this.$emit('siguiente', this.proveedor, 2);
    },
    obtenerProductosLab(){
      this.proveedor.idProductoLaboratorio = null
      this.listProductosByLab = this.productosLaboratorios.filter(id => id.idLaboratorio === this.proveedor.idLaboratorio)
    },
    reset(){
      this.proveedor = {
        idLaboratorio: null,
        idProductoLaboratorio: null,
      }
    },
  }
}
</script>


